import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import IndustryTabs from "./industryTabs";

const Industry = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Industry</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Industry" }, { title: breadcrumb }]}
        />
      </div>
      <IndustryTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default Industry;
